import Navbar from 'components/Navbar';
import SettingSidebar from 'components/Navbar/SettingsSidebar';
import React from 'react';
import { NAV_BAR_HEIGHT_REM } from 'utils/dimensions';
import AntitrustAssessmentForm from './AntitrustAssessmentForm';

const AntitrustAssessment: React.FC = () => {
  const warningBarOffset =
    document != null &&
    document.getElementById != null &&
    document.getElementById('customer-warning')?.offsetHeight;

  return (
    <div
      className="min-w-screen bg-white"
      style={{
        height: `calc(100vh - ${warningBarOffset || 0}px)`,
      }}
    >
      <Navbar />
      <div
        className="flex flex-row"
        style={{
          height: `calc(100vh - ${warningBarOffset || 0}px - ${NAV_BAR_HEIGHT_REM}rem)`,
        }}
      >
        <SettingSidebar />
        <div className="flex-1 h-full overflow-y-auto">
          <AntitrustAssessmentForm />
        </div>
      </div>
    </div>
  );
};

export default AntitrustAssessment;
